import ResidentSizePrice from './ResidentSizePrice';

export default ResidentSizePrice;